export type TierUnlockLevel = 'professional' | 'enterprise';

/** Sidebar routes that unlock on Starter → Professional. */
export const NAV_PROFESSIONAL_UNLOCKS: Partial<Record<string, true>> = {
  '/admin/payments': true,
  '/admin/programs': true,
  '/admin/bookings': true,
  '/admin/play-events': true,
  '/admin/academy/settings': true,
};

/** Bookings sub-tabs that unlock on Starter → Professional. */
export const BOOKINGS_TAB_PROFESSIONAL_UNLOCKS: Partial<
  Record<'waitlist' | 'eoi' | 'private-requests', true>
> = {
  waitlist: true,
  eoi: true,
  'private-requests': true,
};

/** Payments sub-tabs that unlock on Starter → Professional. */
export const PAYMENTS_TAB_PROFESSIONAL_UNLOCKS: Partial<Record<'settings', true>> = {
  settings: true,
};

/** Payments sub-tabs that unlock on Professional → Enterprise. */
export const PAYMENTS_TAB_ENTERPRISE_UNLOCKS: Partial<Record<'accounting', true>> = {
  accounting: true,
};

/** Settings sub-tabs: administrators unlock on Pro; re-highlight on Enterprise for unlimited admins. */
export const SETTINGS_TAB_PROFESSIONAL_UNLOCKS: Partial<Record<'administrators', true>> = {
  administrators: true,
};

export const SETTINGS_TAB_ENTERPRISE_UNLOCKS: Partial<Record<'administrators', true>> = {
  administrators: true,
};

/** Academy settings sub-tabs that unlock on Starter → Professional. */
export const ACADEMY_SETTINGS_TAB_PROFESSIONAL_UNLOCKS: Partial<Record<'advanced', true>> = {
  advanced: true,
};

/** Academy settings sub-tabs re-highlighted on Professional → Enterprise (e.g. SMS limits). */
export const ACADEMY_SETTINGS_TAB_ENTERPRISE_UNLOCKS: Partial<Record<'advanced', true>> = {
  advanced: true,
};

export function getNavTierUnlockLevel(path: string): TierUnlockLevel | null {
  return NAV_PROFESSIONAL_UNLOCKS[path] ? 'professional' : null;
}

export function getBookingsTabTierUnlockLevel(
  tabId: string,
): TierUnlockLevel | null {
  if (BOOKINGS_TAB_PROFESSIONAL_UNLOCKS[tabId as keyof typeof BOOKINGS_TAB_PROFESSIONAL_UNLOCKS]) {
    return 'professional';
  }
  return null;
}

export function getPaymentsTabTierUnlockLevel(tabId: string): TierUnlockLevel | null {
  if (PAYMENTS_TAB_ENTERPRISE_UNLOCKS[tabId as keyof typeof PAYMENTS_TAB_ENTERPRISE_UNLOCKS]) {
    return 'enterprise';
  }
  if (PAYMENTS_TAB_PROFESSIONAL_UNLOCKS[tabId as keyof typeof PAYMENTS_TAB_PROFESSIONAL_UNLOCKS]) {
    return 'professional';
  }
  return null;
}

export function getSettingsTabTierUnlockLevel(tabId: string): TierUnlockLevel | null {
  if (SETTINGS_TAB_ENTERPRISE_UNLOCKS[tabId as keyof typeof SETTINGS_TAB_ENTERPRISE_UNLOCKS]) {
    return 'enterprise';
  }
  if (SETTINGS_TAB_PROFESSIONAL_UNLOCKS[tabId as keyof typeof SETTINGS_TAB_PROFESSIONAL_UNLOCKS]) {
    return 'professional';
  }
  return null;
}

export function getAcademySettingsTabTierUnlockLevel(tabId: string): TierUnlockLevel | null {
  if (
    ACADEMY_SETTINGS_TAB_ENTERPRISE_UNLOCKS[tabId as keyof typeof ACADEMY_SETTINGS_TAB_ENTERPRISE_UNLOCKS]
  ) {
    return 'enterprise';
  }
  if (
    ACADEMY_SETTINGS_TAB_PROFESSIONAL_UNLOCKS[
      tabId as keyof typeof ACADEMY_SETTINGS_TAB_PROFESSIONAL_UNLOCKS
    ]
  ) {
    return 'professional';
  }
  return null;
}
